import { connect } from "react-redux";
import { Container, Row } from "reactstrap";
import { setBreadcrumbItems } from "../../store/actions";

import UserPanel from "components/Common/Dashboard/UserPanel";
import SocialSource from "components/Common/Dashboard/SocialSource";

const Dashboard = (props) => {
  return (
    <div className="mt-4">
      <Container fluid={true}>
        <UserPanel />
        <Row>
          <SocialSource />
        </Row>
      </Container>
    </div>
  );
};

export default connect(null, { setBreadcrumbItems })(Dashboard);
